import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
import * as typeWriter from "./typewriter.js";
$ = jQuery;





export function leaveAnimation(el){
    gsap.fromTo($("main"), 
        {
            //y:60,
            scale:1,
        },
        {
            delay:0,
            //y:0,
            scale:0.8,
            duration:0.6,
            ease:Power3.easeIn,
        }
    );
    return gsap.fromTo($(el), 
        {
            opacity:1,
        },
        {
            delay:0,
            opacity:0,
            duration:0.6,
            ease:Power3.easeOut,
        }
    ); 
    
}
export function enterAnimation(el){
   

   gsap.fromTo($("main"), 
        {
            //y:60,
            scale:0.8,
        },
        {
            delay:0,
            //y:0,
            scale:1,
            duration:1,
            ease:Power3.easeOut,
        }
    );
    return gsap.fromTo($(el), 
        {
            opacity:0,
        },
        {
            delay:0,
            opacity:1,
            duration:0.6,
            ease:Power3.easeIn,
        }
    ); 
                   
}


export function callback(page){
    typeWriter.write($(".typewriter"));
    if(page == "home"){
        
        
        $("#nav").removeClass("white");
        $(".logo").removeClass("hidden2");
        $(".social-box").removeClass("hide");
        $(".phone-box").removeClass("hide");
        $(".noise").removeClass("black");
        
    }
    if(page == "mensen"){
        $("#nav").removeClass("white");
        $(".logo").removeClass("hidden2");
        $(".social-box").removeClass("hide");
        $(".phone-box").removeClass("hide");
        $("#page-mensen p.small").addClass("hide");
        $(".noise").removeClass("black");
        setTimeout(function (e) {
            $("#page-mensen p.small").removeClass("hide");
        }, 1600);
    }
    if(page == "contact"){
        $("#nav").addClass("white");
        $(".logo").addClass("hidden2");
        $(".social-box").addClass("hide");
        $(".phone-box").addClass("hide");
        $(".noise").addClass("black");
    }
}